import React from 'react'
import { OrderProduct } from '../../entities/order-product/OrderProduct'
import Modal from '../modal/Modal'
import ProductDeclineForm from '../product-decline-form/ProductDeclineFormContainer'
import ProductItem from '../product-item/ProductItem'

export interface IOwnProps {
  product:  OrderProduct
  open:     boolean
  onClose:  () => void
}

export type IProps = IOwnProps

const ProductDeclineModal:React.FC<IProps> = (props) => {
  const {
    product,
    open,
    onClose,
  } = props

  return (
    <Modal
      modalName='product-decline'
      open={open}
      onClose={onClose}
      header={() => (
        <ProductItem
          product={product}
          shouldShowControls={false}
          shouldOpenModal={false}
          isModal={true}
        />
      )}
    >
      <ProductDeclineForm
        product={product}
        onSubmit={onClose}
      />
    </Modal>
  )
}

export default ProductDeclineModal
